var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BookedTrip } from '@ibe/models';
import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../../store';
import * as BookedTripActions from '../../../../store/actions/booked-trip.actions';
import { SidebarService } from '@ibe/services/ui';
import { INDRAMybService } from '@ibe/services';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import { INDRAExtraSidebar } from '../ancillaries/extra-sidebar.indra.abstract';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRAAncillariesSelectionService } from '@ibe.services/ancillaries-selection.indra.service';
import { INDRAAncillariesShoppingCartService } from '@ibe.services/ancillaries-shopping-cart.indra.service';
import { EXTRAS_ANCILLARY_INSURANCE, TRANSLATION_INSURANCE, SESSION_VAR_KEY_MARKET, SESSION_VAR_KEY_CURRENCY, COUNTRY_CODE_HUNGARY, INSURANCE_INFO_REQUIRED_MARKETS, SESSION_VAR_KEY_PASSENGERS } from '@ibe.config';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { INDRAGoogleAnalyticsService, EVENT_PRODUCT_BRAND_CHUBB_INSURANCE, EVENT_ACTION_ADD_CART, EVENT_ACTION_REM_CART } from '@ibe.services/google.analytics.indra.service';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';
import { INDRACurrencyPipe } from '@ibe.services/currency.indra.pipe';
var INDRATravelInsuranceComponent = /** @class */ (function (_super) {
    __extends(INDRATravelInsuranceComponent, _super);
    function INDRATravelInsuranceComponent(sidebarService, route, router, store, ibeAdminService, ancillaryService, indraBookingService, indraMybService, ancillariesSelectionSrv, ancillariesShoppingCartSrv, dateService, googleAnalytics, bfmStorage, currencyService, storageService, ibeAdminConfigService, currencyPipe, paymentInfoService) {
        var _this = _super.call(this, sidebarService, route, router, indraBookingService, indraMybService, ibeAdminService, ancillariesSelectionSrv, ancillariesShoppingCartSrv, EXTRAS_ANCILLARY_INSURANCE, dateService, googleAnalytics, storageService, store, currencyPipe, paymentInfoService) || this;
        _this.ancillaryService = ancillaryService;
        _this.indraBookingService = indraBookingService;
        _this.ancillariesSelectionSrv = ancillariesSelectionSrv;
        _this.ancillariesShoppingCartSrv = ancillariesShoppingCartSrv;
        _this.dateService = dateService;
        _this.googleAnalytics = googleAnalytics;
        _this.bfmStorage = bfmStorage;
        _this.currencyService = currencyService;
        _this.ibeAdminConfigService = ibeAdminConfigService;
        _this.currencyPipe = currencyPipe;
        _this.paymentInfoService = paymentInfoService;
        _this.isAlive = true;
        _this.triedToSubmit = false;
        _this.booking$ = _this.store.select(fromStore.getSelectedBookedTrip);
        _this.translation = TRANSLATION_INSURANCE;
        _this.defaultLanguage = 'en';
        _this.isMarketWithInfoNeeded = false;
        _this.isModificationDisallowed = false;
        _this.allSubscriptions = [];
        _this.insuranceFreePaxText = '';
        // get market and process for business rules related to market
        _this.market = sessionStorage.getItem(SESSION_VAR_KEY_MARKET);
        if (_this.market === COUNTRY_CODE_HUNGARY) {
            _this.form = new FormGroup({
                insurance: new FormControl(null, [Validators.required]),
                subConfirm1: new FormControl(null, [Validators.required]),
                subConfirm2: new FormControl(null, [Validators.required]),
                subConfirm3: new FormControl(null, [Validators.required]),
                subConfirm4: new FormControl(null, [Validators.required])
            });
        }
        else {
            _this.form = new FormGroup({ insurance: new FormControl(null, [Validators.required]) });
        }
        if (INSURANCE_INFO_REQUIRED_MARKETS.includes(_this.market)) {
            _this.isMarketWithInfoNeeded = true;
        }
        // get 'isBookingCreated' if existing in URL query params
        var isBookingCreatedParam = _this.route.snapshot.paramMap.get('isBookingCreated');
        if (isBookingCreatedParam === 'true') {
            _this.isModificationDisallowed = true;
        }
        // get insurance object from sidebar service
        _this.insuranceItems = _this.sidebarService.getSidebarParameters()[0];
        _this.insurance = _this.INDRA_translate(_this.translation.PLAN, _this.insuranceItems.plan.ibeAdminKey);
        return _this;
    }
    INDRATravelInsuranceComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.language = sessionStorage.getItem('language');
        this.ibeAdminService.loadTranslations('tap', ['header'], this.language);
        this.booking$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (trip) {
            if (trip) {
                _this.booking = trip;
                _this.totalPrice = _this.insuranceItems.quoteInfo && _this.insuranceItems.quoteInfo != null ? +_this.insuranceItems.quoteInfo.mountToPaid : 0;
                _this.currencyUnit = _this.insuranceItems.quoteInfo && _this.insuranceItems.quoteInfo != null ? _this.currencyService.INDRA_getCurrencySymbol(_this.insuranceItems.quoteInfo.currency).unit : '';
                // this.setParams();
            }
        });
        var formValueSubscription = this.form.valueChanges
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function () { return _this.triedToSubmit = false; });
        this.allSubscriptions.push(formValueSubscription);
        this.insurancePricePerPax = this.INDRA_getInsurancePricePerPax(this.insuranceItems);
        this.INDRA_setDocumentLinks(this.insuranceItems, this.language);
        if (this.market === COUNTRY_CODE_HUNGARY) {
            this.INDRA_validateCheckBox();
        }
        this.INDRA_checkForInfant();
    };
    INDRATravelInsuranceComponent.prototype.INDRA_setDocumentLinks = function (insurance, language) {
        if (insurance) {
            var baseURL = this.ibeAdminConfigService.getConfigurationValue('insurance.insuranceDocumentURL');
            if (insurance.plan && insurance.plan.conditions && insurance.plan.conditions.length > 0) {
                this.specificInsuranceDocLink = this.INDRA_getDocumentLink(insurance.plan.conditions, baseURL, language, this.defaultLanguage);
            }
            if (insurance.termsAndConditions) {
                this.termsAndConditionDocLink = this.INDRA_getDocumentLink(insurance.termsAndConditions, baseURL, language, this.defaultLanguage);
            }
            if (insurance.preContractualDoc) {
                this.preContractualDocLink = this.INDRA_getDocumentLink(insurance.preContractualDoc, baseURL, language, this.defaultLanguage);
            }
            if (insurance.covidDocumentURL) {
                var covidURLDocObject = insurance.covidDocumentURL;
                this.specificCovidDocLink = covidURLDocObject[language] ? baseURL + covidURLDocObject[language] : baseURL + covidURLDocObject['default'];
            }
            if (insurance.privacyPolicy && insurance.privacyPolicy.length) {
                this.privacyPolicyLink = this.INDRA_getPrivacyPolicyLink(insurance.privacyPolicy, language, this.defaultLanguage);
            }
        }
    };
    INDRATravelInsuranceComponent.prototype.INDRA_getDocumentLink = function (documentList, baseURL, selectedLanguage, defaultLanguage) {
        var defaultDocURLObj = documentList.find(function (el) { return el.lang === defaultLanguage; });
        var docURLObj = documentList.find(function (el) { return el.lang === selectedLanguage; });
        if (docURLObj && docURLObj.link) {
            return baseURL + docURLObj.link;
        }
        else if (defaultDocURLObj && defaultDocURLObj.link) {
            return baseURL + defaultDocURLObj.link;
        }
        return null;
    };
    INDRATravelInsuranceComponent.prototype.INDRA_getPrivacyPolicyLink = function (policyList, selectedLanguage, defaultLanguage) {
        var defaultPolicy = policyList.find(function (el) { return el.lang === defaultLanguage; });
        var policy = policyList.find(function (el) { return el.lang === selectedLanguage; });
        if (policy && policy.link) {
            return policy.link;
        }
        else if (defaultPolicy && defaultPolicy.link) {
            return defaultPolicy.link;
        }
        return null;
    };
    INDRATravelInsuranceComponent.prototype.INDRA_handleDocLinkClick = function (url) {
        return window.open(url);
    };
    INDRATravelInsuranceComponent.prototype.INDRA_getInsurancePricePerPax = function (plan) {
        if (plan && plan.elements && plan.elements.length > 0) {
            var pricePerPax = plan.elements.find(function (el) { return el.name == 'PricePerson'; });
            return pricePerPax && pricePerPax.value ? pricePerPax.value : '';
        }
        else {
            return '';
        }
    };
    INDRATravelInsuranceComponent.prototype.setParams = function () {
        if (!this.insurance && this.booking.insurance && this.booking.insurance.length) {
            this.insurance = this.booking.insurance[0].value;
        }
    };
    INDRATravelInsuranceComponent.prototype.INDRA_checkInsurance = function () {
        var _this = this;
        if (this.booking['insurance'] && this.booking['insurance'].length > 0) {
            var hasThisInsurance = this.booking['insurance'].some(function (el) { return el.name === _this.insuranceItems.plan.description; });
            return hasThisInsurance;
        }
        else {
            return false;
        }
    };
    INDRATravelInsuranceComponent.prototype.INDRA_onSubmit = function () {
        this.triedToSubmit = true;
        if (this.form.valid && this.form.get('insurance').value) {
            this.INDRA_insuranceAdd();
        }
    };
    INDRATravelInsuranceComponent.prototype.INDRA_insuranceAdd = function () {
        var _this = this;
        var params = {
            provider: 'CHUBB',
            idReservation: '2224UMFV',
            description: this.insuranceItems.plan.description,
            currency: this.insuranceItems.quoteInfo != null ? this.insuranceItems.quoteInfo.currency : '',
            amount: this.insuranceItems.quoteInfo != null ? +this.insuranceItems.quoteInfo.mountToPaid : 0,
            status: 'OK',
            bookableItemId: '2224UMFV',
            extraInfo: {
                insuranceItems: this.insuranceItems
            }
        };
        this.ancillaryService.INDRA_addExternalReservation(params, EXTRAS_ANCILLARY_INSURANCE)
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (res) {
            if (res && res.status === '200' && res.reservations.CHUBB) {
                var booked_trip = _this.bfmStorage.INDRA_getActiveBookedTrip();
                var chubb = res.reservations.CHUBB;
                if (chubb && chubb.length && chubb[0]) {
                    var plan = chubb[0];
                    plan.insurancePlan = _this.insuranceItems;
                }
                booked_trip['insurance'] = chubb;
                _this.bfmStorage.INDRA_setActiveBookedTrip(booked_trip);
                _this.booking = Object.assign(new BookedTrip(null, null, null), _this.booking, {
                    insurance: [{ name: _this.insuranceItems.plan.description, value: res.reservations.CHUBB[0], price: res.reservations.CHUBB[0].amount }]
                });
                _this.store.dispatch(new BookedTripActions.PutBookedTripAction(_this.booking));
                _this.INDRA_registerGA_travelInsurance();
                _this.paymentInfoService.setUpdateBookingTotals(true);
            }
            _this.INDRA_handleClose();
        }, function (err) {
            _this.paymentInfoService.setUpdateBookingTotals(true);
            _this.INDRA_handleClose();
        });
    };
    INDRATravelInsuranceComponent.prototype.INDRA_insuranceRemove = function () {
        var _this = this;
        this.ancillaryService.INDRA_removeExternalReservation('CHUBB').subscribe(function (res) {
            var booked_trip = _this.bfmStorage.INDRA_getActiveBookedTrip();
            var bookedTripInsurance = booked_trip.insurance[0];
            booked_trip['insurance'] = null;
            _this.bfmStorage.INDRA_setActiveBookedTrip(booked_trip);
            var bookTrip = Object.assign(new BookedTrip(null, null, null), _this.booking, { insurance: null });
            _this.store.dispatch(new BookedTripActions.PutBookedTripAction(bookTrip));
            _this.INDRA_removeGA_travelInsurance(bookedTripInsurance);
            _this.paymentInfoService.setUpdateBookingTotals(true);
            _this.INDRA_handleClose();
        }, function (err) {
            _this.paymentInfoService.setUpdateBookingTotals(true);
            _this.INDRA_handleClose();
        });
    };
    INDRATravelInsuranceComponent.prototype.INDRA_hasErrors = function (control) {
        return this.triedToSubmit && !control.value;
    };
    INDRATravelInsuranceComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
        for (var _i = 0, _a = this.allSubscriptions; _i < _a.length; _i++) {
            var sub = _a[_i];
            if (sub) {
                sub.unsubscribe();
            }
        }
    };
    INDRATravelInsuranceComponent.prototype.INDRA_printImage = function () {
        var IMAGE = 'fast_track.jpg';
        return 'url(assets/images/ancillaries/includes/insurances.jpg)';
    };
    INDRATravelInsuranceComponent.prototype.INDRA_translate = function (type, key) {
        if (key && type) {
            return this.ibeAdminService.getTranslationValue(this.translation.MODULE + "." + this.translation.PROVIDER + "." + type + "." + key);
        }
        else if (key) {
            return this.ibeAdminService.getTranslationValue(this.translation.MODULE + "." + this.translation.PROVIDER + "." + key);
        }
        return '';
    };
    INDRATravelInsuranceComponent.prototype.INDRA_registerGA_travelInsurance = function () {
        var activeBooking = this.bfmStorage.INDRA_getActiveBookedTrip();
        var eventDataLayerObject = this.googleAnalytics.INDRA_createGA_ExternalAncillarySingleProduct(EVENT_PRODUCT_BRAND_CHUBB_INSURANCE, activeBooking.insurance[0]);
        eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(EVENT_ACTION_ADD_CART);
        this.googleAnalytics.INDRA_GA_addToCart(sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY), eventDataLayerObject);
    };
    INDRATravelInsuranceComponent.prototype.INDRA_removeGA_travelInsurance = function (bookedTripInsurance) {
        var eventDataLayerObject = this.googleAnalytics.INDRA_createGA_ExternalAncillarySingleProduct(EVENT_PRODUCT_BRAND_CHUBB_INSURANCE, bookedTripInsurance);
        eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(EVENT_ACTION_REM_CART);
        this.googleAnalytics.INDRA_GA_removeFromCart(sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY), eventDataLayerObject);
    };
    INDRATravelInsuranceComponent.prototype.INDRA_validateCheckBox = function () {
        var _this = this;
        var insurance = this.form.get('insurance').valueChanges.subscribe(function (value) {
            if (!value && value !== null) {
                _this.form.controls['insurance'].setValue(null);
                return;
            }
            if (_this.form.get('subConfirm1').value && _this.form.get('subConfirm2').value && _this.form.get('subConfirm3').value && _this.form.get('subConfirm4').value) {
                return;
            }
            else if (value) {
                _this.form.controls['subConfirm1'].setValue(true);
                _this.form.controls['subConfirm2'].setValue(true);
                _this.form.controls['subConfirm3'].setValue(true);
                _this.form.controls['subConfirm4'].setValue(true);
            }
        });
        var subConfirm1 = this.form.get('subConfirm1').valueChanges.subscribe(function (value) {
            if (!value && value !== null) {
                _this.form.controls['subConfirm1'].patchValue(null);
                return;
            }
            if (_this.form.get('insurance').value) {
                return;
            }
            else if (value && _this.form.get('subConfirm2').value && _this.form.get('subConfirm3').value && _this.form.get('subConfirm4').value) {
                _this.form.controls['insurance'].setValue(true);
            }
        });
        var subConfirm2 = this.form.get('subConfirm2').valueChanges.subscribe(function (value) {
            if (!value && value !== null) {
                _this.form.controls['subConfirm2'].patchValue(null);
                return;
            }
            if (_this.form.get('insurance').value) {
                return;
            }
            else if (_this.form.get('subConfirm1').value && value && _this.form.get('subConfirm3').value && _this.form.get('subConfirm4').value) {
                _this.form.controls['insurance'].setValue(true);
            }
        });
        var subConfirm3 = this.form.get('subConfirm3').valueChanges.subscribe(function (value) {
            if (!value && value !== null) {
                _this.form.controls['subConfirm3'].patchValue(null);
                return;
            }
            if (_this.form.get('insurance').value) {
                return;
            }
            else if (_this.form.get('subConfirm1').value && _this.form.get('subConfirm2').value && value && _this.form.get('subConfirm4').value) {
                _this.form.controls['insurance'].setValue(true);
            }
        });
        var subConfirm4 = this.form.get('subConfirm4').valueChanges.subscribe(function (value) {
            if (!value && value !== null) {
                _this.form.controls['subConfirm4'].patchValue(null);
                return;
            }
            if (_this.form.get('insurance').value) {
                return;
            }
            else if (_this.form.get('subConfirm1').value && _this.form.get('subConfirm2').value && _this.form.get('subConfirm3').value && value) {
                _this.form.controls['insurance'].setValue(true);
            }
        });
        this.allSubscriptions.push(insurance);
        this.allSubscriptions.push(subConfirm1);
        this.allSubscriptions.push(subConfirm2);
        this.allSubscriptions.push(subConfirm3);
        this.allSubscriptions.push(subConfirm4);
    };
    INDRATravelInsuranceComponent.prototype.INDRA_checkForInfant = function () {
        var passengers = JSON.parse(sessionStorage.getItem(SESSION_VAR_KEY_PASSENGERS));
        if (passengers && passengers['infants'] && passengers['infants'] > 0) {
            this.insuranceFreePaxText = this.INDRA_translate('label', 'coveredFreeOfCharge');
        }
    };
    return INDRATravelInsuranceComponent;
}(INDRAExtraSidebar));
export { INDRATravelInsuranceComponent };
